export default function trimHttps(url) {
    return url.replace(/https?:\/\//, '');
};
